export const Global: any = {

    //Fixed Screen size
    SCREEN_FW: 2200,
    SCREEN_FH: 960,

    //Screen size
    SCREEN_W: window.innerWidth,
    SCREEN_H: window.innerHeight,

    //Initial Screen size
    SCREEN_IW: window.innerWidth,
    SCREEN_IH: window.innerHeight,

    //Coordinates of screen center
    SCREEN_CX: window.innerWidth * 0.5,
    SCREEN_CY: window.innerHeight * 0.5,
    DPR: window.devicePixelRatio,
    SCREEN_RATIO: 1,
    SCALE_RATIO: 1,

    //Delay
    OrientationDelay: 200,
    ResizeDelay: 50,

    //GAME DATA
    LEVEL: 1
}